import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, useFeatureFlags } from '@smarty/shared';
import { storePath } from '@/config/routes.config';
// La tabla de portones vive en `elPortonDelPlan`: la lee también quien decide si ofrece un botón.
import { elPortonDelPlan } from '@/lib/dropshipping/elPortonDelPlan';
import { useSoyVendedorDelDrop } from '@/hooks/useSoyVendedorDelDrop';
import { useSoloAlmacenResuelto } from '@/hooks/useSoloAlmacen';

/**
 * El portón de los roles de la red: se monta UNA vez, arriba de todas las rutas del panel, y deja
 * pasar sólo lo que la lista blanca del plan nombra. Lo demás va al Inicio.
 *
 * ⭐ HOY CUIDA DOS ROLES. El dropshipper (`drop`) desde el 21-sep, y el almacén (`almacen`) desde el
 *    24-sep. Son dos listas porque son dos oficios opuestos: el drop importa productos y no toca
 *    existencias; el almacén los crea y el stock es su dato más importante.
 *
 * 🪤 UNA TABLA Y NO UNA CADENA DE `if`. Con dos roles la diferencia no se nota; con el tercero
 *    —el courier, que el plan tiene en la fase 12— una cadena de `if` es donde alguien se olvida
 *    de agregar el suyo y el rol nuevo queda con el panel entero abierto. Acá, un plan sin entrada
 *    pasa de largo a propósito y con una sola línea que lo dice.
 *
 * 🪤 NO SE APAGA EN DESARROLLO (a diferencia de `FeatureProtectedRoute`): el rol es un dato, igual
 *    que en `RutaSoloParaTiendas`. En 5173 el founder abrió la ficha de un producto como
 *    Revendedor Demo, tocó «Venta por WhatsApp» y cayó en Chats: eso es lo que esto cierra.
 *
 * 🪤 Mientras el plan carga NO tapa la pantalla: `FeatureFlagsContext` recuerda el plan de la
 *    sesión anterior, así que casi siempre ya se sabe; y un spinner acá frenaría el arranque de
 *    TODAS las cuentas por una que entra por primera vez a una URL ajena. En cuanto el plan llega,
 *    redirige.
 */
export function PortonDelRolDrop({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { storeSlug } = useAuth();
  const { planType } = useFeatureFlags();
  // El vendedor de un drop tiene su portón, más chico que el del plan (ver `rutasDelVendedorDrop`).
  const vendedor = useSoyVendedorDelDrop();

  // Un plan de rol tiene portón aunque la cuenta sea interna: el rol es un dato (ver `elPortonDelPlan`).
  // 🪤 RESUELTO, no el booleano: mientras la base no dijo si es proveedor, el portón usa la lista ancha (ver el hook).
  const soloAlmacen = useSoloAlmacenResuelto() === true;
  const porton = elPortonDelPlan(planType, { vendedor, soloAlmacen });
  if (porton && !porton.deja(pathname)) {
    return <Navigate to={storeSlug ? storePath(storeSlug, porton.vuelveA) : porton.vuelveA} replace />;
  }
  return <>{children}</>;
}
